import * as React from 'react';
import { action } from 'mobx';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class PortalHeaderTopbarUser extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { userStore, portalStore } = this.context;

    if (!userStore.session) {
      return null;
    }

    return (
      <div
        className="topbar-item"
        style={{ cursor: 'pointer' }}
        onClick={action(() => (portalStore.isUserPanelOpen = !portalStore.isUserPanelOpen))}
      >
        <div className="btn btn-icon w-auto d-flex align-items-center btn-lg px-2">
          <div className="d-flex text-right pr-3">
            <span className="text-white opacity-50 font-weight-bold font-size-sm d-none d-md-inline mr-1">Hallo,</span>
            <span className="text-white font-weight-bolder font-size-sm d-none d-md-inline">{userStore.session.user.name}</span>
          </div>
          <span className="symbol symbol-35">
            <img src={userStore.session.user.image} className="h-75 align-self-end" />
          </span>
        </div>
      </div>
    );
  }
}
